const ready = require('./utilities').ready;

const GSI_SCRIPT_SELECTOR = 'script[src*="accounts.google.com/gsi/client"]';
const INIT_TIMEOUT_MS = 10000;
const POLL_INTERVAL_MS = 100;

ready(init);

function init() {
  const el = document.getElementById('google-one-tap');
  if (!el) return;
  if (document.body.dataset.userSignedIn === 'true') return;

  waitForGoogleIdentity(() => {
    const loginUri = buildLoginUri(el.dataset.loginUri, el.dataset.followGuruId);

    window.google.accounts.id.initialize({
      client_id: el.dataset.clientId,
      ux_mode: 'redirect',
      login_uri: loginUri,
      itp_support: true,
    });

    window.google.accounts.id.prompt((notification) => {
      if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        return;
      }
    });
  });
}

function buildLoginUri(loginUri, followGuruId) {
  if (!followGuruId) return loginUri;

  const separator = loginUri.includes('?') ? '&' : '?';
  return `${loginUri}${separator}follow_guru_id=${encodeURIComponent(followGuruId)}`;
}

function waitForGoogleIdentity(callback) {
  if (window.google?.accounts?.id) {
    callback();
    return;
  }

  if (!document.querySelector(GSI_SCRIPT_SELECTOR)) {
    return;
  }

  const startedAt = Date.now();
  const interval = setInterval(() => {
    if (window.google?.accounts?.id) {
      clearInterval(interval);
      callback();
      return;
    }

    if (Date.now() - startedAt >= INIT_TIMEOUT_MS) {
      clearInterval(interval);
    }
  }, POLL_INTERVAL_MS);
}
